import state     from "./demands.state";
import mutations from "./demands.mutations";
import actions   from "./demands.actions";
import getters   from "./demands.getters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
